import { useState } from 'react';
import PropTypes from 'prop-types';

function IconText({
  className,
  width,
  height,
  id,
  color,
  hoverColor,
  viewBox,
  force,
}) {
  const [mainColor, setMainColor] = useState(color);
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
    >
      <defs>
        <path
          id="icon-text"
          d="M20 4.889v2.667c0 .533-.356.888-.889.888s-.889-.355-.889-.888V5.778H12.89v12.444h1.778c.533 0 .889.356.889.89 0 .532-.356.888-.89.888H9.334c-.533 0-.889-.356-.889-.889s.356-.889.89-.889h1.777V5.778H5.778v1.778c0 .533-.356.888-.89.888-.532 0-.888-.355-.888-.888V4.889C4 4.356 4.356 4 4.889 4H19.11c.533 0 .889.356.889.889z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id={id} fill="#fff">
          <use xlinkHref="#icon-text" />
        </mask>
        <g fill={force ? color : mainColor} mask={`url(#${id})`}>
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
}

IconText.defaultProps = {
  className: undefined,
  width: 24,
  height: 24,
  color: '#989898',
  hoverColor: '#989898',
  viewBox: '0,0,24,24',
  force: false,
};

IconText.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
  force: PropTypes.bool,
};

export default IconText;
